import React from 'react';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';

function BaseGrid(props) {
    return (
        <Container
            component="main"
            maxWidth="md"
        >

            <div>
                <Grid
                    container
                    id="reduce-width"
                    justify="center"
                    spacing={5}
                >
                    <Grid
                        id="shadow-round"
                        item
                        sm={8}
                        spacing={2}
                        xs={12}
                    >

                        <Grid
                            container
                            id='padding-20'
                            spacing={2}
                        >
                            {props.children}
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </Container>

    );
}

export default BaseGrid;
